import React from "react";
import { Button } from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";

interface GoogleSignInButtonProps {
  onClick: () => void;
  loading?: boolean;
}

export const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onClick,
  loading = false,
}) => {
  return (
    <Button
      variant="contained"
      onClick={onClick}
      disabled={loading}
      startIcon={<GoogleIcon />}
      sx={{
        backgroundColor: "#4285F4",
        color: "white",
        "&:hover": {
          backgroundColor: "#357AE8",
        },
        "&:disabled": {
          backgroundColor: "#ccc",
        },
        minWidth: 200,
        padding: "10px 24px",
      }}
    >
      {loading ? "Signing in..." : "Sign in with Google"}
    </Button>
  );
};
